<template>
    <div>
         <div class="stats-section" style="display: flex!important">
    <div class="text-content">
       
      <p
                      class="headline policeLato font-weight-regular pb-3"
                      style="font-size: 2.2rem; line-height: 1.2;"
                    >
                      <span class="d-block d-sm-none" style="font-size: 1.3rem;">
                        {{ $t('apropos.stat_text_content[0]') }}<br>
                        {{ $t('apropos.stat_text_content[1]') }}
                      </span>
                      <span class="d-none d-sm-block">
                        {{ $t('apropos.stat_text_content[0]') }}<br>
                        {{ $t('apropos.stat_text_content[1]') }}
                      </span>
                    </p>
    </div>

                  <div class="stats stats-responsive ms-auto">
                      <div class="stat-item">
                      <h2>2</h2>
                      <p>{{ $t('apropos.data_content[2]') }}</p>
                      </div>
                      <div class="divider"></div>
                      <div class="stat-item">
                      <h2 id="devisCounter"></h2>
                      <p>{{ $t('apropos.data_content[3]') }}</p>
                      </div>
                      <div class="divider"></div>
                      <div class="stat-item">
                      <h2 id="PartnerCounter"></h2>
                      <p>{{ $t('apropos.data_content[0]') }}</p>
                      </div>
                    </div>
        
  </div>
    </div>

</template>

<script>
import {CountUp} from "countup.js";
import Api from '../../services/Api';

export default {
  name: "stats_section",
  data () {
    return {
        CountDevis: null,
        Countpartners: null,
        CountpartnersTemp: 0,
    }
  },
  methods: {
     //Nombre de devis total
    getDevisCount() {
                Api().get('devis/all')
                    .then(response => {
                        if (response) {
                            this.CountDevis = response.data.count;
                            console.log(this.CountDevis);
                          const countUp = new CountUp('devisCounter', this.CountDevis, this.CountUpOptions);
                          countUp.start();
                        } else {
                            this.CountDevis = 100
                        }
                    })
            },
    getPartnersCount() {
                Api().get('partenaire')
                    .then(response => {
                        if (response) {
                            this.Countpartners = response.data.count;
                          const countUp = new CountUp('PartnerCounter', this.Countpartners, this.CountUpOptions);
                          countUp.start();
                        } else {
                            this.Countpartners = 10
                            const countUp = new CountUp('PartnerCounter', this.Countpartners, this.CountUpOptions);
                            countUp.start();
                        }
                    })
            },
  },
  mounted() {
    this.getPartnersCount();
     this.getDevisCount();
  },
};
</script>

<style scoped>
.stats-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
    /* padding: 2rem; */
  background-color: #ffa409;
}
.stats-section-mobile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffa409;
  justify-content: center;
}

.text-content p {
  font-size: 2.2rem;
  font-weight: 600;
  color: #2b2b2b;
  float: left;
}

.stats {
  display: flex;
  align-items: center;
  gap: 4rem;
}

.stat-item {
  text-align: center;
}

.stat-item h2 {
  font-size: 5rem;
  color: #fff; /* Blue tone */
  margin: 0;
  float: left;
}

.stat-item p {
  font-size: 2rem;
  color: #2b2b2b;
  font-weight: 500;
  text-align: left;
}

.divider {
  width: 2px;
  height: 70px;
  background-color: #fff;
}
.policeLato{
        font-family: Lato, "Helvetica Neue", Arial, sans-serif
    }
</style>
